export type AppleIapNotificationItem = {
  id?: number;
  notificationUuid?: string;
  notificationType?: string;
  subtype?: string;
  bizCategory?: string;
  environment?: string;
  bundleId?: string;
  productId?: string;
  transactionId?: string;
  originalTransactionId?: string;
  appAccountToken?: string;
  priceMilli?: number;
  currency?: string;
  quantity?: number;
  purchaseTime?: string;
  revocationTime?: string;
  revocationReason?: string;
  signedDate?: string;
  decodedPayload?: string | Record<string, unknown>;
  createTime?: string;
  updateTime?: string;
};

export const BIZ_CATEGORY_OPTIONS = [
  { label: '支付成功', value: 'PAY_SUCCESS' },
  { label: '支付失败', value: 'PAY_FAIL' },
  { label: '退款申请', value: 'REFUND_REQUEST' },
  { label: '退款', value: 'REFUND' },
  { label: '其他', value: 'OTHER' }
];

export const bizCategoryLabelByValue: Record<string, string> = Object.fromEntries(
  BIZ_CATEGORY_OPTIONS.map(({ value, label }) => [value, label])
);
